/**
 * Reports for one run, opened from the QC step or the runs table.
 *
 * Wraps `PipelineReportsTab` rather than rendering its own tables: the reports
 * are server-side and identical wherever they are read from, and a second
 * implementation here would be a second thing to keep in step with the SQL.
 *
 * Passing `runId` is what makes this a report about *this* import rather than
 * everything in staging — the same distinction the QC report has needed since
 * staging stopped being cleared between runs.
 *
 * Title / row count / Export live in `PipelineReportsTab` so they share one
 * header (avoids duplicating "KPIs Reports" under the dialog chrome).
 */
import { Dialog, DialogContent } from "./ui/dialog";
import { PipelineReportsTab } from "../tabs/PipelineReportsTab";

export function RunReportsDialog({
  open,
  onOpenChange,
  runId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  runId?: string | null;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl gap-0 overflow-hidden p-0">
        <div className="max-h-[70vh] overflow-y-auto">
          <PipelineReportsTab runId={runId ?? null} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
